import React from "react";
import { useNavigate } from "react-router-dom";
import { ReceiptNotFoundIcon } from "src/assets/icons/ReceiptNotFoundIcon";
import { ErrorWarningIcon } from "src/assets/icons/ErrorWarningIcon";
import { GoBackIcon } from "src/assets/icons/GoBackIcon";
import { ReceiptErrorType, receiptErrorTypeMaps } from "src/lib/api/types";
import { colors } from "@aifi-ml/design-system-variables";
import { styles } from "./styles";


interface ReceiptErrorProps {
  errorType: ReceiptErrorType;
  onRetry?: () => void;
}

export const ReceiptError: React.FC<ReceiptErrorProps> = ({
  errorType,
  onRetry,
}) => {
  const navigate = useNavigate();
  const errorConfig = receiptErrorTypeMaps[errorType];
  const errorCode = errorType === ReceiptErrorType.NOT_FOUND ? "404" : "500";

  const handleGoBack = () => {
    navigate(-1);
  };

  const iconBgColor = errorType === ReceiptErrorType.NOT_FOUND 
    ? colors.light['color/surface/background/tertiary']
    : colors.light['color/surface/tag/error'];

  const iconWrapperStyle = {
    ...styles.iconWrapper,
    backgroundColor: iconBgColor,
  };

  return (
    <div style={styles.errorPanel}>
      <div style={styles.errorCodeBackground}>{errorCode}</div>
      <div style={styles.errorCard}>
        <div style={iconWrapperStyle}>
          {errorType === ReceiptErrorType.NOT_FOUND ? (
            <ReceiptNotFoundIcon width={40} height={40} />
          ) : (
            <ErrorWarningIcon width={40} height={40} />
          )}
        </div>
        <h2 style={styles.errorTitle}>{errorConfig.title}</h2>
        <p style={styles.errorMessage}>{errorConfig.message}</p>
        {errorConfig.goBack && (
          <button
            onClick={handleGoBack}
            style={styles.goBackLink}
            onMouseEnter={(e) => {
              e.currentTarget.style.textDecoration = 'underline';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.textDecoration = 'none';
            }}
          >
            <GoBackIcon width={24} height={24} color={colors.light['color/text/general/active']} />
            {errorConfig.goBack}
          </button>
        )}
      </div>
    </div>
  );
};
